export const ImportStates = Object.freeze({
    "COMPLETED": "COMPLETED",
    "FAILED":"FAILED",
    "ONGOING": "ONGOING"
})